import React from "react";
import "./ClimateInfo.scss";
import { Button } from "../../Button/Button";

interface IProps {
    year: number;
    showClimateInfo: boolean;
    setShowClimateInfo: (state: boolean) => void;
}

const contents: { frost: {title: string, content: string}, temperature: {title: string, content: string} } = {
    frost: {
        title: 'Frost days',
        content: 'Frost days is the number of days when the minimum daily temperature is below 0 degrees Celsius.',
    },
    temperature: {
        title: 'Temperature',
        content: 'Max temperature is the maximum daily temperature; the peak of the day expressed in degrees Celsius.',
    }
}


export function ClimateInfo({showClimateInfo, setShowClimateInfo, year}: IProps) {
    const contentKey = year %2 ? 'frost' : 'temperature';
    const content = contents[contentKey];
    return (
        <div className={`climate-info-wrapper ${showClimateInfo ? 'show' : ''}`}>
            <div className="contents-wrapper">
                <h4>{content.title}</h4>
                <p>{content.content}</p>

            </div>
            <div className="close-button-wrapper"  onClick={() => setShowClimateInfo(false)}>
                <Button className={'close-button'}>&times;</Button>
            </div>
        </div>
    )
}
